import React, { useCallback } from 'react';

import Button from '@atlaskit/button';
import { token } from '@atlaskit/tokens';

import { clearWhiteboardVersion } from './whiteboard-version';

interface WhiteboardVersionProps {
	version: string | null;
	serverSpot?: number;
	relaySpot?: number;
}

const styles: React.CSSProperties = {
	position: 'absolute',
	left: token('space.250'),
	top: token('space.800'),
};

export const WhiteboardExitVersion = ({
	version,
	serverSpot,
	relaySpot,
}: WhiteboardVersionProps) => {
	const onClearVersion = useCallback(async () => {
		await clearWhiteboardVersion();
		location.replace(location.pathname);
	}, []);

	if (!version && !serverSpot && !relaySpot) {
		return null;
	}

	const typeTag = version ? 'version' : 'spot';
	const versionTag = version ? `(${version})` : '';
	const serverTag = serverSpot ? `canvas-server-${serverSpot}` : '';
	const relayTag = relaySpot ? `canvas-relay-${relaySpot}` : '';

	const description = [typeTag, 'deploy', versionTag, serverTag, relayTag].filter(Boolean);

	return (
		//eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
		<Button style={styles} onClick={onClearVersion}>
			Exit {description.join(' ')}
		</Button>
	);
};
